<template>
  <div class="restrictions-filter">
    <IngredientsWarningPopover/>
    <b>Avoid:</b>
    <b-btn-group size="sm">
      <b-btn v-for="restriction in currentFilter" :key="restriction.name" :title="restriction.shortLabel"
             :class="{ active: restriction.active }" @click="toggleRestrictions(restriction)">
        <img :hidden="restriction.active" :src="require(`../../assets/restrictions/${restriction.name}.svg`)"
             :alt="restriction.label"/>
        <img :hidden="!restriction.active" :src="require(`../../assets/restrictions/${restriction.name}-off.svg`)"
             :alt="restriction.label"/>
        <span>{{ restriction.shortLabel }}</span>
      </b-btn>
    </b-btn-group>
  </div>
</template>

<script>
import IngredientsWarningPopover from './ingredients-warning-popover'

const SORT = ['dairy_free', 'gluten_free', 'nut_allergy', 'soy_allergy', 'seafood_allergy']

export default {
  props: ['user', 'diets'],

  data() {
    return {
      currentFilter: this.restrictions,
    }
  },

  computed: {
    restrictions() {
      let restrictions = this.diets ? this.diets.filter(diet => diet.level === null) : []
      restrictions.forEach(restriction => restriction.active = false)
      restrictions = restrictions.sort((a, b) => SORT.indexOf(a.name) < SORT.indexOf(b.name) ? -1 : 1)
      return restrictions
    }
  },

  watch: {
    user() {
      this.setRestrictions(this.restrictions)
    }
  },

  created() {
    this.setRestrictions(this.restrictions)
  },

  methods: {
    setRestrictions(restrictions) {
      let activate = []
      restrictions.forEach(restriction => {
        if (this.user.restrictions.find(name => name === restriction.name)) activate.push(restriction)
      })

      this.toggleRestrictions(activate, true)
    },

    toggleRestrictions(restrictions, reset) {
      if (!restrictions.hasOwnProperty('length')) restrictions = [restrictions]

      this.currentFilter = this.restrictions.map(restriction => {
        let toggle = restrictions.find(toggle => toggle.name === restriction.name)
        restriction.active = toggle ? !toggle.active : (reset ? false : restriction.active)
        return restriction
      })

      this.$emit('change', this.restrictions.filter(restriction => restriction.active))
    },
  },

  components: {
    IngredientsWarningPopover,
  }
}
</script>

<style lang="scss">
.restrictions-filter {
  .bt-info-circle {
    color: $blue;
    margin-right: 0.5rem;
  }

  .btn {
    color: transparent;
    background-color: transparent !important;
    border: 0;
    width:60px;
    font-size: $font-size-xs;

    &.active {
      color: $red !important;
    }

    &:hover {
      color: $red;
    }

    &:focus {
      box-shadow: none !important;
    }

    img {
      display: block;
      width: 40px;
      height: 40px;
      overflow: hidden;
      margin: 0 auto 5px auto;
    }
  }
}
</style>